import { useQuery, useQueryClient } from '@tanstack/react-query';

export interface IApiError {
  status: number;
}

const API_ERROR_QUERY_KEY = ['apiError'] as const;

export const useApiError = () => {
  const queryClient = useQueryClient();

  const { data: apiError } = useQuery<IApiError | null>({
    queryKey: API_ERROR_QUERY_KEY,
    queryFn: () => null,
    enabled: false,
    initialData: null,
  });

  const setApiError = (error: IApiError) => {
    queryClient.setQueryData<IApiError>(API_ERROR_QUERY_KEY, error);
  };

  return {
    apiError,
    setApiError,
  };
};
